var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vacation-types layout" },
    [
      _c("vacation-type-sidesheet", {
        ref: "vacationTypeModal",
        on: { remove: _vm.removeType },
      }),
      _c("remove-type-modal", {
        ref: "removeTypeModal",
        on: { remove: _vm.removeType },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [_vm._v("Типы отпусков")]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button2", {
                attrs: {
                  size: "small",
                  icon: {
                    icon: "bookmark",
                    activeColor: "white",
                  },
                  tooltip: {
                    text: "Добавить в закладки",
                    activeText: "Убрать из закладок",
                  },
                  "active-color": "blue",
                  active: _vm.bookmark,
                },
                on: {
                  click: function ($event) {
                    _vm.bookmark = !_vm.bookmark
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button2", {
                attrs: {
                  responsive: true,
                  size: "small",
                  label: "Новый тип отпуска",
                  icon: { icon: "plus", color: "primary" },
                },
                on: { click: _vm.addType },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "vacation-types__content" },
        [
          _c("c-input", {
            staticClass: "vacation-types__search",
            attrs: {
              placeholder: "Поиск по типу",
              type: "text",
              clearable: true,
              icon: "search",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          !_vm.loading && !_vm.vacationTypes.length
            ? _c("div", { staticClass: "vacation-types__empty" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.search
                        ? "Ничего не найдено. Попробуйте изменить параметры поиска."
                        : "Не добавлено ни одного типа отпуска"
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          _vm.loading
            ? _c("c-loader", {
                staticClass: "vacation-types__loader",
                attrs: {
                  active: _vm.loading,
                  label: "Данные загружаются",
                  height: 300,
                },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "vacation-types__list" },
            [
              _c(
                "draggable",
                {
                  staticClass: "item-container",
                  attrs: {
                    tag: "div",
                    "ghost-class": "sortable__ghost",
                    group: "list",
                    "force-fallback": true,
                  },
                  on: { change: _vm.resortTypes },
                  model: {
                    value: _vm.vacationTypes,
                    callback: function ($$v) {
                      _vm.vacationTypes = $$v
                    },
                    expression: "vacationTypes",
                  },
                },
                _vm._l(_vm.vacationTypes, function (type) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isTypeVisible(type),
                          expression: "isTypeVisible(type)",
                        },
                      ],
                      key: type.id,
                      staticClass: "vacation-type",
                    },
                    [
                      _c("div", { staticClass: "vacation-type__wrapper" }, [
                        _c("div", { staticClass: "vacation-type__data" }, [
                          _c(
                            "span",
                            {
                              staticClass: "vacation-type__name",
                              staticStyle: { "white-space": "nowrap" },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { "white-space": "normal" } },
                                [
                                  _vm._v(" " + _vm._s(type.name) + " "),
                                  type.timesheet_code
                                    ? _c(
                                        "span",
                                        { staticClass: "vacation-type__code" },
                                        [
                                          _vm._v(
                                            " (" +
                                              _vm._s(type.timesheet_code) +
                                              ") "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.hover.blur.top",
                                    value: "Цвет в графике отпусков",
                                    expression: "'Цвет в графике отпусков'",
                                    modifiers: {
                                      hover: true,
                                      blur: true,
                                      top: true,
                                    },
                                  },
                                ],
                                staticClass: "vacation-type__color",
                                style: {
                                  color: type.color || _vm.defaultColor,
                                },
                              }),
                            ]
                          ),
                          type.description
                            ? _c(
                                "span",
                                { staticClass: "vacation-type__description" },
                                [_vm._v(" " + _vm._s(type.description) + " ")]
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "vacation-type__actions" },
                          [
                            _c("c-button2", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.hover.blur.top",
                                  value: "Редактировать",
                                  expression: "'Редактировать'",
                                  modifiers: {
                                    hover: true,
                                    blur: true,
                                    top: true,
                                  },
                                },
                              ],
                              staticClass: "vacation-type__edit",
                              attrs: { size: "iconic", icon: "edit" },
                              on: {
                                click: function ($event) {
                                  return _vm.editType(type)
                                },
                              },
                            }),
                            type.canDelete
                              ? _c("c-button2", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.hover.blur.top",
                                      value: "Удалить",
                                      expression: "'Удалить'",
                                      modifiers: {
                                        hover: true,
                                        blur: true,
                                        top: true,
                                      },
                                    },
                                  ],
                                  staticClass: "vacation-type__remove",
                                  class: {
                                    "vacation-type__remove--disabled":
                                      !!type.is_sick,
                                  },
                                  attrs: {
                                    size: "iconic",
                                    disabled: !!type.is_sick,
                                    icon: { icon: "trash", color: "secondary" },
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onRemoveTypeClick(type)
                                    },
                                  },
                                })
                              : _vm._e(),
                            !type.canDelete
                              ? _c("c-button2", {
                                  staticClass:
                                    "vacation-type__remove vacation-type__remove--disabled",
                                  attrs: {
                                    id: "vacation-type-blocked-" + type.id,
                                    size: "iconic",
                                    icon: { icon: "trash", color: "secondary" },
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                })
                              : _vm._e(),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  placement: "top",
                                  container: "app",
                                  boundary: "window",
                                  target: "vacation-type-blocked-" + type.id,
                                  triggers: "hover blur",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "reference-uniform-category-empty-tooltip",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "reference-uniform-category-empty-tooltip-icon",
                                        attrs: {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 14 14",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("circle", {
                                          attrs: {
                                            cx: "7",
                                            cy: "7",
                                            r: "6.5",
                                            fill: "white",
                                            stroke: "#FF238D",
                                          },
                                        }),
                                        _c("circle", {
                                          attrs: {
                                            cx: "7",
                                            cy: "10",
                                            r: "1",
                                            fill: "#FF238D",
                                          },
                                        }),
                                        _c("rect", {
                                          attrs: {
                                            x: "6",
                                            y: "3",
                                            width: "2",
                                            height: "5",
                                            rx: "1",
                                            fill: "#FF238D",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "reference-uniform-category-empty-tooltip-text",
                                      },
                                      [
                                        _vm._v(
                                          ' В данный момент удаление невозможно, так как тип отпуска используется в разделе "Графики отпусков и больничных" '
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("c-button-2", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.hover.blur.top",
                                  value: "Переместить",
                                  expression: "'Переместить'",
                                  modifiers: {
                                    hover: true,
                                    blur: true,
                                    top: true,
                                  },
                                },
                              ],
                              staticClass: "vacation-type__move handle",
                              attrs: {
                                size: "iconic",
                                icon: "arrows-constructor",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      type.description
                        ? _c(
                            "div",
                            { staticClass: "vacation-type__description" },
                            [_vm._v(" " + _vm._s(type.description) + " ")]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }